import cloneDeep from 'lodash/cloneDeep';
import Papa from 'papaparse';

import { formatData } from '../data_format';

/**
 * Builds tab-delimited (Excel/Sheets friendly) text from react-table v7 style
 * columns (`accessor`/`Header`/`Footer`/`format`) and rows. Used by the Survey
 * response tables' "Copy Table" action.
 * @param  {Array}  columns
 * @param  {Array}  data
 * @return {String} csv output
 */
export const getCopyTableValue = ({ columns, data }) => {
  const headerGroups = columns.filter((column) => Array.isArray(column?.columns));

  if (headerGroups?.length > 0) {
    columns = [];

    headerGroups.forEach((headerGroup) => {
      columns = columns.concat(headerGroup.columns);
    });
  }

  const footerValues = columns.map((column) => column.Footer);
  const headerAccessors = columns.map((column) => column.accessor);
  const headerNames = columns.map((column) => column.Header);
  const rows = cloneDeep(data);

  columns.forEach((column) => {
    const accessors = column?.accessor.split(';');

    rows.forEach((row) => {
      let value;
      for (const [accessorIndex] of accessors.entries()) {
        if (row?.original[accessors[accessorIndex]] !== 'NAN_SENTINEL') {
          value = row?.original[accessors[accessorIndex]];
        } else {
          break;
        }
      }
      row[column?.accessor] = formatData({
        format: column?.format,
        value: value || 'NAN_SENTINEL',
      });
    });
  });

  const footer = footerValues.some((value) => value)
    ? '\n' + Papa.unparse({ data: [], fields: footerValues }, { delimiter: '\t', header: true })
    : '';
  const header = Papa.unparse({ data: [], fields: headerNames }, { delimiter: '\t', header: true });
  const parsedData = Papa.unparse(
    { data: rows, fields: headerAccessors },
    { columns, delimiter: '\t', header: false }
  );

  return header + parsedData + footer;
};
